// Utility to safely return a company name respecting confidentiality.
// If the request is confidential, prefer the company's private alias when present,
// otherwise fall back to "Private Company". When not confidential, return the
// actual company name if available, otherwise the same fallback.

export function confidentialityAwareCompanyName(
  company: { company_name?: string | null; private_alias?: string | null } | any,
  isConfidential: boolean
): string {
  const fallbackName = "Private Company";

  if (isConfidential) {
    const alias: string | undefined = company?.private_alias ?? undefined;
    const trimmed = alias?.trim();
    return trimmed && trimmed.length > 0 ? trimmed : fallbackName;
  }

  const name: string | undefined = company?.company_name ?? undefined;
  const trimmed = name?.trim();
  return trimmed && trimmed.length > 0 ? trimmed : fallbackName;
}
